/*
    PROPS
        isLoading
        disabled

    isLoading >> disabled

    IF isLoading === true
       then button is also disabled; not true for the other way around.
       That is, the button is not isLoading if disabled === true

    Shows loading animation inside the button
    whenever the submit is happening
    takes in isLoading prop from the parent
    so that it knows that some stuff is happening

    Expects the parent div to be positioned relative

    Animation will extend till the padding/margin on button container.
*/
import React from 'react';

import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import UpwardButtonLoader from '../loaders/UpwardButtonLoader';

class UpwardLoadingButton extends React.Component {
   render() {
      const { isLoading, className, disabled, ...rest } = this.props;
      return (
         <Button
            className={`loading-button ${ className ? className : '' }`}
            {...rest}
            // AFTER the spread, or a passed disabled prop silently overrides the loading
            // lock and the button stays clickable while showing its loader
            disabled={isLoading || disabled}
         >
            { this.props.isLoading ? <UpwardButtonLoader/> : '' }
            {this.props.children}
         </Button>
      );
   }
}

UpwardLoadingButton.propTypes = {
   isLoading: PropTypes.bool,
   disabled: PropTypes.bool,
};

export default UpwardLoadingButton;
